"use strict";
var Observable_1 = require('../../Observable');
var reduce_1 = require('../../operator/reduce');
Observable_1.Observable.prototype.reduce = reduce_1.reduce;
//# sourceMappingURL=reduce.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/~/rxjs/add/operator/reduce.js
// module id = ../../../../rxjs/add/operator/reduce.js
// module chunks = 4